import React from 'react'

export const LeadSourceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
   props
) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      {...props}
   >
      <g opacity="0.7">
         <path
            d="M15.8138 18.8333C15.8138 17.3146 13.7618 16.0833 11.2305 16.0833C8.69916 16.0833 6.64714 17.3146 6.64714 18.8333M19.4805 16.0837C19.4805 14.956 18.3492 13.9869 16.7305 13.5625M2.98047 16.0837C2.98047 14.956 4.11172 13.9869 5.73047 13.5625M16.7305 9.8831C17.2931 9.37956 17.6471 8.64779 17.6471 7.83334C17.6471 6.31455 16.4159 5.08334 14.8971 5.08334C14.1928 5.08334 13.5503 5.34812 13.0638 5.78357M5.73047 9.8831C5.16787 9.37956 4.8138 8.64779 4.8138 7.83334C4.8138 6.31455 6.04502 5.08334 7.5638 5.08334C8.26813 5.08334 8.91061 5.34812 9.39714 5.78357M11.2305 13.3333C9.71169 13.3333 8.48047 12.1021 8.48047 10.5833C8.48047 9.06455 9.71169 7.83334 11.2305 7.83334C12.7493 7.83334 13.9805 9.06455 13.9805 10.5833C13.9805 12.1021 12.7493 13.3333 11.2305 13.3333Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </g>
   </svg>
)
